import styled from '@emotion/styled';

export const SResizeHandle = styled.div`
  height: 100%;
  position: absolute;
  width: 4px;
  right: -2px;
  top: 0;
  z-index: 2;
  :hover {
    cursor: col-resize;
  }
`;

export const SResizeTh = styled.th`
  :last-child {
    ${SResizeHandle} {
      display: none;
    }
  }
`;

export const SWrapper = styled.div`
  .custom-ant-table {
    tr > td {
      padding-block: 5px;
      height: 55px;
    }

    .ant-spin {
      .ant-spin-dot-item {
        background-color: rgba(0, 0, 0, 1);
      }
    }

    .ant-pagination {
      .ant-pagination-prev {
        color: rgba(0, 0, 0, 0.88);
      }

      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        .ant-pagination-item-link {
          background: transparent !important;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &.ant-pagination-disabled {
          &:hover {
            border: 1px solid #d9d9d9 !important;
          }
        }
        border: 1px solid #d9d9d9 !important;
        &:hover {
          border: 1px solid rgba(0, 0, 0, 1) !important;
          background: transparent !important;
        }
      }

      .ant-pagination-item-active {
        a {
          color: rgba(0, 0, 0, 1);
          &:hover {
            color: rgba(0, 0, 0, 1);
          }
        }

        border: 1px solid rgba(0, 0, 0, 1) !important;
      }
    }
  }
`;
